import {Component, Input, OnInit} from '@angular/core';
import {NgbActiveModal} from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-modal-generic-info',
  templateUrl: './modal-generic-info.component.html',
  styleUrls: ['./modal-generic-info.component.scss']
})
export class ModalGenericInfoComponent implements OnInit {

  @Input() title: string;
  @Input() body: string;

  constructor(public activeModal: NgbActiveModal) { }

  ngOnInit(): void {
  }
}
